export enum OpenAddHyperlinkDialogReason {
    View,
    Edit,
    Add
}